import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormFlowWrapper from '../../theme/wrappers/FormFlowWrapper';
import validators from '../../../utils/forms/validators';
import formatters from '../../../utils/forms/formatters';
import { userTypeSelect } from '../../../utils/forms/preconfiguredInputs';
import { updateUser } from '../../../store/calls';
import FormFlowStepForm from '../../theme/forms/FormFlowStepForm';
import { addErrorAlert, addSuccessAlert } from '../../../store/calls/alertLoadingDispatch';
import { toggleGlobalLoader } from '../../../store/actions/session';
import api from '../../../store/api';
import BaseForm from '../../theme/forms/BaseForm';
import user from '../../../store/reducers/user';

const editFields = [
    {
        type: "text",
        dataKey: "first_name",
        label: "First Name",
        inputClasses: "is-medium",
        ...validators.isStringOfMinLength(2),
    },
    {
        type: "text",
        dataKey: "last_name",
        label: "Last Name",
        inputClasses: "is-medium",
        ...validators.isStringOfMinLength(2),
    },
    {
        type: "phone",
        dataKey: "cell_phone",
        label: "Cell Phone",
        inputClasses: "is-medium",
        placeholder: "(XXX) XXX-XXXX",
        formatter: formatters.phone.formatter,
        ...validators.isPhoneNumber,
    },
    {
        type: "text",
        dataKey: "email",
        label: "Email",
        inputClasses: "is-medium",
        ...validators.isEmail,
    },
    {
        dataKey: "role",
        label: "Select the option that best describes your role",
        inputClasses: "is-medium is-fullwidth",
        ...userTypeSelect,
        ...validators.exists
    },
    {
        type: "text",
        dataKey: "company",
        label: "Company",
        inputClasses: "is-medium",
    }
]


function EditProfile(props) {

    const [userData, setUserData] = useState({});
    const tokenData = useSelector(state => state.user.decodedTokenData);


    useEffect(() => {
        api.get(`/users/${tokenData.user_id}/`)
            .then((res) => {
                setUserData({
                    ...res.data,
                    ...res.data.profile || {},

                })
            })
    }, []);

    return (
        <FormFlowWrapper>
            <div className='form-wrapper'>
                <div className='card mb-4'>
                    <div className='card-content'>
                        <p className='is-size-3 has-text-primary py-3'>Edit Profile</p>
                        <BaseForm
                            inputs={editFields.map((field) => ({ ...field, value: userData[field.dataKey] }))}
                            submitText="Update Profile"
                            onSubmit={(data) => {
                                toggleGlobalLoader(true)
                                updateUser(data)
                                    .then(() => {
                                        addSuccessAlert("Profile updated successfully")
                                    })
                                    .catch((err) => {
                                        addErrorAlert("There was a problem updating your profile")
                                    })
                                    .finally(() => {
                                        toggleGlobalLoader(false)
                                    })
                            }}
                            otherButtons={
                                <button
                                    className="button"
                                    onClick={() => {
                                        props.history.push('/reset-password')
                                    }}
                                >Reset Password</button>
                            }
                        />
                    </div>
                </div>

                <div className='card'>
                    <div className='card-content'>
                        <p className='is-size-3 has-text-primary py-3'>Referral Link</p>
                        <p>Share this link with anyone looking for commerical financing. When they close their first deal, we send you $1000. Easy as that!</p>

                        <div className='is-flex my-4 is-align-items-center'>
                            <p className='has-text-weight-semibold has-text-primary'>https://app.cleanfi.com/create-account?ref={userData.hash_id}</p>
                            <button className='button is-primary ml-6 is-outlined' onClick={() => {
                                navigator.clipboard.writeText(`https://app.cleanfi.com/create-account?ref=${userData.hash_id}`)
                                addSuccessAlert("Link copied to clipboard")
                            }}>Copy</button>
                        </div>
                    </div>

                </div>
            </div>
        </FormFlowWrapper>
    )


}


export default EditProfile;